'use client';

import { FirebaseClientProvider } from '@/firebase';
import { I18nProvider } from '@/i18n/provider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <I18nProvider>
      <FirebaseClientProvider>{children}</FirebaseClientProvider>
    </I18nProvider>
  );
}
